/* @flow */

const formatarTelefone = ({ ddd, numero }: { ddd: string, numero: string }) => (
    `(${ddd}) ${numero.replace(/(\d)([\d]{4})$/, '$1-$2')}`
);

export default formatarTelefone;
